/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://5ma5s4k5avcw3bqfjsrmy6rp44.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "spotify",
            "endpoint": "https://ktko0qxk41.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:9962cca9-2a80-430d-b278-8b588a324693",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_2L0MJhzp2",
    "aws_user_pools_web_client_id": "2dbgogoqpak05rk5hr0e4np055",
    "oauth": {}
};


export default awsmobile;
